import React, { Component, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { baseURL, isHebrew } from '../../../App';
import { Box, Divider, Button, Typography } from '@material-ui/core';
import logo from '../../../components/NewNavbar/logoWhite.svg';
import { useTranslation } from 'react-i18next';
import { HOME } from '../../../constants/routes';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
  topBar: {},
  buttons: {
    fontFamily: 'Assistant',
    padding: theme.spacing(1.5),
    textTransform: 'none',
  },
}));

const LogoBox = () => {
  const history = useHistory();
  return (
    <Box>
      <div onClick={() => history.push()}>
        <img
          alt="logo"
          src={logo}
          // className={`clickable`}
          style={{ marginTop: '5px', marginBottom: '5px' }}
        />
      </div>
    </Box>
  );
};

export const Topbar = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const { t, i18n } = useTranslation();
  const history = useHistory();
  return (
    <Box className={classes.topBar}>
      <Box
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        p={2}
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <LogoBox />
          <Typography variant="h5">
            <Box fontWeight="bold" ml={0.5} mr={0.5} color="white">
              {t('biz_lp_top_bar_for_business')}
            </Box>
          </Typography>
        </Box>
        <Box display="flex">
          <Box
            color="white"
            mr={1}
            ml={1}
            display={{ xs: 'none', sm: 'block' }}
          >
            <Button
              onClick={() => history.push(`${HOME}`)}
              disableElevation
              className={classes.buttons}
              color="inherit"
              variant="outlined"
              id="browse-button"
            >
              {t('biz_lp_top_bar_browse_creators')}
            </Button>
          </Box>
          <Box display={{ xs: 'none', sm: 'block' }}>
            <Button
              onClick={() => props.onCTAClicked()}
              disableElevation
              className={classes.buttons}
              color="primary"
              variant="contained"
              id="chat-button"
            >
              {t('biz_lp_top_bar_contact_a_rep')}
            </Button>
          </Box>
          <Box variant="contained" display={{ xs: 'block', sm: 'none' }}>
            <Button
              onClick={() => props.onCTAClicked()}
              color="primary"
              variant="contained"
              disableElevation
              className={classes.buttons}
              id="chat-button-mobile"
            >
              {t('biz_lp_top_bar_contact_us')}
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider style={{ background: 'rgba(255, 255, 255, 0.3)' }} />
    </Box>
  );
};
